import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../redux/store";
import { logMessage } from "../utils/logMessage";

type KycGuardProps = {
  children: React.ReactNode;
};

const KycGuard: React.FC<KycGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { currentUser, loading } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    // console.log("Loading:", loading);
    // console.log("Current User:", currentUser);

    // Wait for loading to complete before making decisions
    if (loading) {
      return;
    }

    // Redirect to /auth if the user is not authenticated
    // console.log(currentUser);
    if (!currentUser) {
      logMessage("User is not authenticated", "from KycGuard");
      // navigate("/auth");
      return;
    }

    // Allow admins and superadmins
    if (
      currentUser.role.role_code !== "CUSTOMER" &&
      currentUser.role.role_code !== "ENTERPRISE"
    ) {
      return;
    }

    // Handle customer-specific logic
    if (currentUser.customer) {
      const { isActivate, isKycSubmitte } = currentUser.customer;

      if (!isActivate) {
        navigate(isKycSubmitte ? "/kyc-under-review" : "/auth/kyc");
        return;
      }
    } else {
      logMessage("Customer data missing in user object");
    }
  }, [currentUser, loading, navigate]);

  // Display a fallback while loading
  if (loading) {
    return <div>Loading user information...</div>;
  }

  // Render the children if no redirect is triggered
  return <>{children}</>;
};

export default KycGuard;
